import { render, staticRenderFns } from "./PTruckFill.vue?vue&type=template&id=36d2677a"
import script from "./PTruckFill.vue?vue&type=script&lang=js"
export * from "./PTruckFill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports